import React, { useRef, useEffect, memo } from 'react';

interface JotformIframeProps {
    src: string;
    className?: string;
}

const iframeStyle: React.CSSProperties = {
    width: '100%',
    height: '300px',
    border: 'none',
};

const JotformIframe: React.FC<JotformIframeProps> = ({ src, className }) => {
    const iframeRef = useRef<HTMLIFrameElement>(null);

    useEffect(() => {
        const handleMessage = (e: MessageEvent) => {
            if (typeof e.data !== 'string') return;

            const args = e.data.split(':');
            const formId = args[2];
            const iframe = iframeRef.current;
            if (!iframe) return;

            const srcBase = src.split('?')[0];
            if (formId && !srcBase.endsWith(formId)) return;

            switch (args[0]) {
                case 'scrollIntoView':
                    iframe.scrollIntoView();
                    break;
                case 'setHeight':
                    iframe.style.height = `${args[1]}px`;
                    break;
                case 'collapseErrorPage':
                    if (iframe.clientHeight > window.innerHeight) {
                        iframe.style.height = `${window.innerHeight}px`;
                    }
                    break;
                case 'reloadPage':
                    window.location.reload();
                    break;
            }

            if (e.origin.includes('jotform') && iframe.contentWindow) {
                iframe.contentWindow.postMessage(
                    JSON.stringify({
                        type: 'urls',
                        value: {
                            docurl: encodeURIComponent(document.URL),
                            referrer: encodeURIComponent(document.referrer),
                        },
                    }),
                    '*'
                );
            }
        };

        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, [src]);

    return (
        <iframe
            ref={iframeRef}
            style={iframeStyle}
            className={className}
            src={src}
            title="Jotform"
        />
    );
};

export default memo(JotformIframe);
